import React from 'react';

type Industry = {
    mcc: string;
    category: string;
};

type IndustrySelectProps = {
    industries: Industry[];
    value: string;
    onChange: (value: string) => void;
    label?: string;
    invalid?: boolean;   // marca el campo en rojo (requerido sin seleccionar)
};

const IndustrySelect: React.FC<IndustrySelectProps> = ({ industries, value, onChange, label, invalid }) => {
    return (
        <div>
            {label && <label htmlFor="industry" className="form-label small text-muted mb-1">{label}</label>}
            <select
                id="industry"
                className={`form-select${invalid ? ' is-invalid' : ''}`}
                value={value}
                onChange={(e) => onChange(e.target.value)}
            >
                <option value="">Seleccione la industria</option>
                {industries.map((industry) => (
                    <option key={industry.mcc} value={industry.mcc}>
                        {industry.category}
                    </option>
                ))}
            </select>
            <div className="invalid-feedback">Campo requerido</div>
        </div>
    );
};

export default IndustrySelect;
